<template>
  <b-modal
    v-model="openModal"
    id="modal-1"
    title="Editar tarifa"
    no-close-on-esc
    no-close-on-backdrop
    @hidden="closeModal">
    <ValidationObserver ref="form" >
      <Loading :active="loading" :is-full-page="true"></Loading>
      <b-form @submit.prevent="onSubmit" >
        <b-form-group
          id="input-group-1"
          label="Destino"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            :value="rate.destination"
            type="text"
            readonly
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="input-group-2"
          label="Producto"
          label-for="input-2"
        >
          <b-form-input
            id="input-2"
            :value="rate.service"
            type="text"
            readonly
          ></b-form-input>
        </b-form-group>
        <ValidationProvider name="Precio OW usd" rules="required" v-slot="{ validated, valid }">
          <b-form-group
            id="input-group-3"
            label="OW USD"
            label-for="input-3"
            description="Precio en USD one way."
          >
            <b-form-input
              id="input-3"
              v-model="eRate.ow"
              type="text"
              :state="getState(validated, valid)"
            ></b-form-input>
          </b-form-group>
        </ValidationProvider>
        <ValidationProvider name="Precio RT usd" rules="required" v-slot="{ validated, valid }">
          <b-form-group
            id="input-group-3"
            label="RT USD"
            label-for="input-3"
            description="Precio en USD round trip."
          >
            <b-form-input
              id="input-3"
              v-model="eRate.rt"
              type="text"
              :state="getState(validated, valid)"
            ></b-form-input>
          </b-form-group>
        </ValidationProvider>
        <ValidationProvider name="Precio OW MXN" rules="required" v-slot="{ validated, valid }">
          <b-form-group
            id="input-group-3"
            label="OW MXN"
            label-for="input-3"
            description="Precio en MXN one way."
          >
            <b-form-input
              id="input-3"
              v-model="eRate.mxn"
              type="text"
              :state="getState(validated, valid)"
            ></b-form-input>
          </b-form-group>
        </ValidationProvider>
      </b-form>
    </ValidationObserver>
    <template #modal-footer="{ ok, cancel, hide }">
      <b-button size="sm" variant="primary" @click="onSubmit">
        Guardar
      </b-button>
      <!-- </b-button><b-button size="sm" variant="danger" @click="closeModal()">
        Cancel
      </b-button> -->
    </template>
  </b-modal>
</template>
<script>
  import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
  import { required, email } from 'vee-validate/dist/rules'
  extend('email', email)
  extend('required', required)
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  export default {
    name:'RateEditAdmin',
    components: {FontAwesomeIcon, ValidationObserver, ValidationProvider},
    props:{
      rate: {
        required:true
      },
      isOpen: {
        default: false
      }
    },
    data() {
      return {
        loading: false,
        openModal: this.isOpen,
        eRate: {...this.rate},
        eRate2: this.rate,
      }
    },
    mounted() {
    },
    methods:{
      getState(validated, valid) {
        if (!validated) {
          return null;
        }
        return valid
      },
      closeModal() {
        this.openModal = false;
        this.$emit('close-edit-rate', false)
      },
      onSubmit(e) {
        e.preventDefault()
        const id = this.rate.id
        this.errors = null
        this.updateSuccess = false
        this.$refs.form.validate().then((success) => {
          if (success) {
            this.loading = true
            const url = `${process.env.MIX_APP_URL}${this.$prefixPanel}/rates/${id}/update`
            //this.$store.dispatch('quote/setRequest', this.rq)
            const data = {
              ow: this.eRate.ow,
              rt: this.eRate.rt,
              mxn: this.eRate.mxn,
            }
            this.$axios.post(url, data).then(rs => {
              this.updateSuccess = true
              this.loading = false
              this.eRate2.ow = data.ow
              this.eRate2.rt = data.rt
              this.eRate2.mxn = data.mxn
              //this.loading = false
              this.$bvToast.toast(rs.data.message, {
                title: `Update success`,
                variant: 'success',
                solid: true,
                toaster: 'b-toaster-top-center',
              })
              //location.href = this.urlReturn();
            })
            .catch(error=> {
              if (error.response) {
                this.errors = error.response.data.errors
              }  else {
                this.errors = {
                  unexpected: ['Hubo un error por favor contacte al administrador']
                }
              }
              console.log('error quote', error);
              this.loading = false
            })
          }
        })
      },
    },
    watch:{
      isOpen(newValue) {
        this.openModal = newValue;
      }
    }
  }
</script>